import React, { Component } from "react";
import PropTypes from "prop-types";
import Popover from "./ui/Popover";
import Content from "./Content";
import { Scrollbars } from "react-custom-scrollbars";
import * as sheetActions from "../actions/sheets";
import SortContainer from "./SortContainer";
import TypeUtils from "../lib/TypeUtils";
import { ItemTypes } from "../constants";

export default class ContentPicker extends Component {
  static propTypes = {
    type: PropTypes.object,
    value: PropTypes.array,
    items: PropTypes.array,
    onChange: PropTypes.func,
    dispatch: PropTypes.func,
  };

  static defaultProps = {
    limit: 0,
    create: false,
  };

  static childContextTypes = {
    type: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      enabled: this.canPick(props),
      filter: "",
    };
  }

  getChildContext() {
    const { type } = this.props;
    return { type };
  }

  componentWillReceiveProps(props) {
    const { items, value, onChange } = props;
    if (!items || !items.length) return;

    // remove items if they no longer exist
    const newValue = value
      .slice()
      .filter((id) => !!props.items.filter((model) => model.id === id).length);
    if (newValue.length !== value.length) {
      onChange(newValue);
    }
  }

  canPick({ value, limit }) {
    const content = this.availableContent();
    if (content.length < 1) return false;
    if (!limit || limit === 0) return true;
    return value.length < limit;
  }

  canCreate(available) {
    const { create, value, limit, type } = this.props;
    if (!create || !type) return false;
    if (!limit || limit === 0) return true;
    return value.length < limit;
  }

  availableContent() {
    const { items, value } = this.props;
    return items.filter((item) => value.indexOf(item.id) < 0);
  }

  filterContent = (content) => {
    const { filter } = this.state;
    const filterValue = filter.toLowerCase();

    for (const key in content) {
      const value = (content[key] || "").toString().toLowerCase();
      if (value.indexOf(filterValue) > -1) return true;
    }

    return false;
  };

  onAdd = (e) => {
    e.preventDefault();
    this.refs.picker.setState({ target: e.target, showing: true });
  };

  onDone = (e) => {
    e && e.preventDefault();
    this.refs.picker.setState({ showing: false });
  };

  onCreate = (e) => {
    e.preventDefault();
    const item = { active: true };
    this.props.dispatch(
      sheetActions.set({
        component: "EditContent",
        props: {
          model: item,
          type: this.props.type,
          onCreate: (model) => this.onPick(model),
        },
      })
    );
  };

  onEdit = (item) => {
    this.props.dispatch(
      sheetActions.set({
        component: "EditContent",
        props: { model: item, type: this.props.type },
      })
    );
  };

  onPick = (item) => {
    const { value, onChange, limit, items } = this.props;
    const newValue = [...value, item.id];
    onChange && onChange(newValue);
    if (newValue.length >= limit && limit > 0) {
      this.onDone();
    }
    if (newValue.length >= items.length) {
      this.onDone();
    }
  };

  onRemove = (item) => {
    const { value, onChange } = this.props;
    const index = value.indexOf(item.id);
    const newValue = [...value.slice(0, index), ...value.slice(index + 1)];
    onChange && onChange(newValue);
  };

  onSort = (items) => {
    const { onChange } = this.props;
    onChange && onChange(items.map((model) => model.id));
  };

  onFilter = (e) => {
    const filter = e.target.value;
    this.setState({ filter });
  };

  renderItem = (item) => {
    return (
      <Content
        displayFields
        key={item.id}
        content={item}
        onClick={this.onPick.bind(this, item)}
      />
    );
  };

  renderValue = (item) => {
    return (
      <Content
        displayFields
        key={item.id}
        content={item}
        sortable
        onClick={this.onEdit.bind(this, item)}
      >
        <button
          className="ion-ios-minus-outline"
          onClick={this.onRemove.bind(this, item)}
        />
      </Content>
    );
  };

  render() {
    const { value, items, type } = this.props;
    const { filter } = this.state;
    const available = this.availableContent();
    const canPick = this.canPick(this.props);
    const displayFields = TypeUtils.displayFields(type);
    const listSize = displayFields.length > 2 ? "list-wide" : "";

    return (
      <div>
        <div className="panel content-picker">
          <ul className="list">
            <SortContainer
              itemType={ItemTypes.PICKER}
              items={value.map((id) =>
                items.filter((model) => model.id === id).shift()
              )}
              didSort={this.onSort}
              renderItem={this.renderValue}
            />
          </ul>
          <div className="panel-buttons">
            {canPick && <button onClick={this.onAdd}>Add</button>}
            {this.canCreate(available) && (
              <button onClick={this.onCreate}>Create new</button>
            )}
          </div>
        </div>
        <Popover ref="picker">
          <Scrollbars autoHide autoHeight autoHeightMax={400}>
            <div className="picker-search">
              <input
                type="search"
                placeholder="Search"
                value={filter}
                onChange={this.onFilter}
              />
            </div>
            <ul className={`list ${listSize} picker-list`}>
              {available.filter(this.filterContent).map(this.renderItem)}
            </ul>
          </Scrollbars>
          <div className="actions">
            <button className="done" onClick={this.onDone}>
              Done
            </button>
          </div>
        </Popover>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/ContentPicker.js